import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  storeCount: 0,
  deviceCount: 0,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    changeField: (state, { payload: { key, value } }) => {
      state[key] = value;
    },
  },
});

export const { changeField } = dashboardSlice.actions;

export default dashboardSlice.reducer;
